import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPointer"><Path d="M11.2273 9.12333H16.1364C18.5463 9.12333 20.5 11.0859 20.5 13.5069V14.1416C20.5 18.4817 16.9977 22 12.6773 22C9.77295 22 7.10763 20.3835 5.75492 17.8016L2.5 11.589L3.31885 10.5608C4.07159 9.61558 5.4446 9.46232 6.38553 10.2185L7.40909 11.0411V3.91781C7.40909 2.85863 8.26382 2 9.31818 2C10.3725 2 11.2273 2.85863 11.2273 3.91781V9.12333Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPointer;
